/**
 * String matching utilities for international city names.
 * Extracted from WanderAppComplete.jsx for shared use by web and mobile.
 */

// Normalize text for international character support
export const normalizeInternational = (text) => {
  if (!text) return '';
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

// International city name mappings (common alternate spellings/transliterations)
export const INTERNATIONAL_CITY_ALIASES = {
  'tokyo': ['東京', 'tokio', 'tōkyō'],
  'beijing': ['北京', 'peking', 'běijīng'],
  'shanghai': ['上海', 'shànghǎi'],
  'moscow': ['москва', 'moskva', 'moskau'],
  'cairo': ['القاهرة', 'al-qahira', 'kairo'],
  'athens': ['αθήνα', 'athina', 'athen'],
  'rome': ['roma'],
  'florence': ['firenze'],
  'venice': ['venezia', 'venedig'],
  'milan': ['milano', 'mailand'],
  'naples': ['napoli', 'neapel'],
  'munich': ['münchen', 'muenchen'],
  'cologne': ['köln', 'koeln'],
  'vienna': ['wien'],
  'prague': ['praha'],
  'copenhagen': ['københavn', 'kobenhavn'],
  'lisbon': ['lisboa'],
  'seville': ['sevilla'],
  'barcelona': ['barna'],
  'bangkok': ['กรุงเทพ', 'krung thep'],
  'seoul': ['서울', 'seul'],
  'taipei': ['台北', 'taibei'],
  'kyoto': ['京都', 'kioto'],
  'osaka': ['大阪', 'ōsaka'],
  'hong kong': ['香港', 'hongkong'],
  'singapore': ['singapura', 'சிங்கப்பூர்'],
  'delhi': ['दिल्ली', 'new delhi'],
  'mumbai': ['मुंबई', 'bombay'],
  'dubai': ['دبي', 'dubay'],
  'istanbul': ['İstanbul', 'constantinople'],
  'tel aviv': ['תל אביב', 'telaviv'],
  'jerusalem': ['ירושלים', 'al-quds'],
};

// Resolve international city name to standard English name
export const resolveInternationalCity = (input) => {
  if (!input) return null;
  const normalized = normalizeInternational(input);

  for (const [english, aliases] of Object.entries(INTERNATIONAL_CITY_ALIASES)) {
    if (normalized === normalizeInternational(english)) return english;
    for (const alias of aliases) {
      if (normalized === normalizeInternational(alias)) {
        return english.charAt(0).toUpperCase() + english.slice(1);
      }
    }
  }

  return null;
};
